<template>
  <div class="w-full pt-5" :style="hideTab ? 'padding-top: 0' : ''">
    <div class="flex w-full" v-if="!hideTab">
      <div class="border-r border-romanSilver h-6 flex pt-1">
        <BackButton
          label="Back"
          @onClick="$router.back()"
          variant="secondary"
          class="ml-2"
        />
      </div>
      <h1 class="text-xl text-left font-extrabold pl-4 mr-8">
        Performance Reports
      </h1>
      <Breadcrumb :items="breadcrumbs" />
    </div>
    <template>
      <div
        class="w-full p-5 flex mt-2 flex-col"
        :style="hideTab ? 'padding: 0' : ''"
      >
        <div class="w-full flex flex-col">
          <div class="w-full pt-5" :class="hideTab ? '!pt-0' : ''">
            <template v-if="isLoading">
              <div class="mt-20 h-full">
                <Loader size="xxs" :loader-image="true" />
              </div>
            </template>

            <template v-else>
              <div
                class="flex flex-col justify-center items-center gap-5 px-10 py-10 mt-10"
                :class="hideTab ? '!mt-0' : ''"
                v-if="!statusReport"
              >
                <Icon
                  icon-name="comreview_illustration"
                  size=""
                  class-name="w-56 h-56"
                />
                <p
                  class="font-normal text-base leading-5 text-jet text-center w-96"
                >
                  Performance Report not available.
                </p>
              </div>

              <template v-else>
                <template>
                  <div
                    class="flex justify-between items-center"
                    v-if="!hideOverview"
                  >
                    <span
                      class="font-bold text-lg mb-5 mx-3 leading-5 tracking-normal capitalize text-darkPurple"
                    >
                      Performance Status Reports
                    </span>
                  </div>
                  <Card class="px-5 py-2 flex flex-col">
                    <div
                      class="flex justify-between items-center m-1"
                      v-if="!hideOverview"
                    >
                      <div
                        class="flex gap-2 mb-2 font-bold text-sm leading-6 tracking-normal"
                      >
                        <span class="uppercase text-romanSilver"
                          >Employee:</span
                        >
                        <span class="capitalize text-darkPurple">
                          {{ employeeData.fname }}
                          {{ employeeData.lname }}
                        </span>
                      </div>
                    </div>
                    <div class="flex gap-5" v-if="!hideOverview">
                      <div class="flex-1 w-2/12 rounded-md">
                        <img
                          v-if="
                            employeeData.photo !== '' &&
                            employeeData.photo !== null
                          "
                          :src="employeeData.photo"
                          alt="profile"
                          style="
                            height: 183px;
                            width: 183px;
                            border-radius: 5px;
                          "
                        />
                        <div
                          style="
                            height: 183px;
                            width: 183px;
                            border-radius: 5px;
                          "
                          class="text-blueCrayola border text-center font-black text-lg pt-14 mr-2"
                          v-else
                        >
                          {{
                            $getInitials(
                              `${employeeData.fname} ${employeeData.lname}`
                            )
                          }}
                        </div>
                      </div>
                      <div class="flex flex-col flex-3 w-10/12">
                        <div class="flex mb-2 w-full gap-2">
                          <div
                            class="flex flex-1 p-3 shadow rounded-md gap-2 items-start"
                          >
                            <Icon
                              class-name="text-romanSilver"
                              size="xs"
                              icon-name="calendar"
                            />
                            <div class="flex flex-col tracking-wide font-bold">
                              <span class="text-xs text-carrotOrange uppercase"
                                >Designation</span
                              >
                              <span class="text-sm text-jet uppercase">{{
                                employeeData.designation
                              }}</span>
                            </div>
                          </div>
                          <div
                            class="flex flex-1 p-3 shadow rounded-md gap-2 items-start"
                          >
                            <Icon
                              class-name="text-romanSilver"
                              size="xs"
                              icon-name="icon-department"
                            />
                            <div class="flex flex-col tracking-wide font-bold">
                              <span class="text-xs text-blueCrayola uppercase"
                                >Function</span
                              >
                              <span class="text-sm text-jet uppercase">{{
                                employeeData.function
                              }}</span>
                            </div>
                          </div>
                          <div
                            class="flex flex-1 p-3 shadow rounded-md gap-2 items-start"
                          >
                            <Icon
                              class-name="text-romanSilver"
                              size="xs"
                              icon-name="user"
                            />
                            <div class="flex flex-col tracking-wide font-bold">
                              <span
                                class="text-xs text-mediumSeaGreen uppercase"
                                >Line Manager</span
                              >
                              <span
                                class="text-sm text-jet uppercase whitespace-nowrap"
                                >{{ employeeData.lineManager }}</span
                              >
                            </div>
                          </div>
                        </div>
                        <div class="flex mb-4 w-full gap-2">
                          <div
                            class="flex flex-1 p-3 shadow rounded-md gap-2 items-start w-1/3"
                          >
                            <Icon
                              class-name="text-romanSilver"
                              size="xs"
                              icon-name="icon-user-list"
                            />
                            <div class="flex flex-col tracking-wide font-bold">
                              <span class="text-xs text-lite uppercase"
                                >Employee ID</span
                              >
                              <span class="text-sm text-jet uppercase">{{
                                employeeData.employeeId
                              }}</span>
                            </div>
                          </div>
                          <div
                            class="flex flex-2 p-3 shadow rounded-md gap-2 items-start w-2/3"
                          >
                            <Icon
                              class-name="text-romanSilver"
                              size="xs"
                              icon-name="pin"
                            />
                            <div class="flex flex-col tracking-wide font-bold">
                              <span class="text-xs text-flame uppercase"
                                >Office Location</span
                              >
                              <span class="text-sm text-jet uppercase">{{
                                employeeData.location
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 flex justify-between gap-3">
                      <Card class="w-full">
                        <div
                          class="flex justify-between items-center px-3 py-2 uppercase"
                        >
                          <p class="text-jet font-semibold text-sm leading-5">
                            kpi count
                          </p>
                          <p
                            class="text-blueCrayola font-semibold text-sm leading-5"
                          >
                            {{ kpiCount }}
                          </p>
                        </div>
                        <div
                          class="flex justify-between items-center px-3 py-2 uppercase"
                        >
                          <p class="text-jet font-semibold text-sm leading-5">
                            reported
                          </p>
                          <p
                            class="text-blueCrayola font-semibold text-sm leading-5"
                          >
                            {{ reported }}
                          </p>
                        </div>
                      </Card>
                      <Card class="w-full">
                        <div
                          class="flex justify-between items-center px-3 py-2 uppercase"
                        >
                          <p class="text-jet font-semibold text-sm leading-5">
                            Completed Rate (number)
                          </p>
                          <p
                            class="text-blueCrayola font-semibold text-sm leading-5"
                          >
                            {{ completedRate }} of {{ kpiCount }}
                          </p>
                        </div>
                        <div
                          class="flex justify-between items-center px-3 py-2 uppercase"
                        >
                          <p class="text-jet font-semibold text-sm leading-5">
                            Completed Rate (Weight)
                          </p>
                          <p
                            class="text-blueCrayola font-semibold text-sm leading-5"
                          >
                            {{ completedWeight }}%
                          </p>
                        </div>
                      </Card>
                    </div>
                  </Card>
                </template>
                <template v-if="reports.length > 0">
                  <div class="flex items-center justify-end mt-5">
                    <Button
                      v-if="shouldShowReportButton"
                      @click="isOpenNewReport = true"
                      class="w-28 h-10 text-white bg-flame flex items-center justify-center rounded-md"
                    >
                      Report New
                    </Button>
                  </div>
                  <div class="mt-10">
                    <Table
                      :headers="header"
                      :items="reports"
                      :has-checkbox="false"
                      :has-number="false"
                    >
                      <template v-slot:item="{ item }">
                        <div
                          v-if="item.kpa"
                          class="font-semibold text-sm leading-5 tracking-widest"
                        >
                          <span class="text-darkPurple">{{
                            item.data.kpa
                          }}</span>
                        </div>
                        <div
                          v-if="item.kpi"
                          class="font-semibold text-sm leading-5 tracking-widest"
                        >
                          <span class="text-darkPurple">{{
                            item.data.kpi
                          }}</span>
                        </div>
                        <div
                          v-if="item.criteria"
                          class="font-semibold text-sm leading-5 tracking-widest"
                        >
                          <span class="text-darkPurple">{{
                            item.data.criteria
                          }}</span>
                        </div>
                        <div
                          v-if="item.weight"
                          class="font-semibold text-sm leading-5 tracking-widest"
                        >
                          <span class="text-darkPurple">{{
                            item.data.weight
                          }}</span>
                        </div>
                        <div
                          v-if="item.support"
                          class="font-semibold text-sm leading-5 tracking-widest"
                        >
                          <span class="text-darkPurple">{{
                            item.data.support
                          }}</span>
                        </div>
                        <div v-if="item.comments">
                          <span class="text-darkPurple">{{
                            item.data.comments
                          }}</span>
                        </div>
                        <div v-if="item.status">
                          <Badge
                            :label="item.data.status"
                            variant="primary"
                            :background-color="
                              item.data.status === 'completed'
                                ? 'rgba(19, 181, 106, 0.15)'
                                : 'rgba(135, 142, 153, 0.15)'
                            "
                            :color="
                              item.data.status === 'completed'
                                ? '#13B56A'
                                : '#878E99'
                            "
                            class="capitalize"
                            style="
                              margin-right: 12px;
                              font-size: 14px;
                              padding: 12px 10px;
                              height: 35px;
                              border-radius: 5px;
                            "
                          />
                        </div>
                        <div v-if="item.id" class="cursor-pointer">
                          <Menu left top="-150" margin="24" class="my-2">
                            <template v-slot:title>
                              <icon icon-name="more_icon" size="xs" />
                            </template>
                            <div style="width: 150px; padding: 10px 15px">
                              <div
                                @click="
                                  viewReport(
                                    {
                                      name: item.data.kpi,
                                      kpis: [{ criteria: item.data.criteria }],
                                      weight: item.data.weight,
                                      report: { files: item.data.files },
                                      status: item.data.status,
                                      requireSupport: item.data.requireSupport
                                        ? `Yes`
                                        : `No`,
                                      comment: item.data.comments,
                                    },
                                    {
                                      name: item.data.kpa,
                                      id: item.data.kpaTypeId,
                                    },
                                    false
                                  )
                                "
                                class="cursor-pointer flex"
                              >
                                <icon
                                  icon-name="icon-eye"
                                  size="xsm"
                                  class="text-blueCrayola"
                                />
                                <p class="text-sm ml-2">View Report</p>
                              </div>
                            </div>
                          </Menu>
                        </div>
                      </template>
                    </Table>
                  </div>
                </template>
                <template v-else>
                  <div
                    class="flex flex-col justify-center items-center gap-5 px-10 py-10"
                  >
                    <Icon
                      icon-name="comreview_illustration"
                      size=""
                      class-name="w-56 h-56"
                    />
                    <p
                      class="font-normal text-base leading-5 text-jet text-center w-96"
                    >
                      No performance report added. Added performance report will
                      show up here.
                    </p>
                    <Button
                      v-if="shouldShowReportButton"
                      @click="isOpenNewReport = true"
                      class="w-28 h-10 text-white bg-flame flex items-center justify-center rounded-md"
                    >
                      Report New
                    </Button>
                  </div>
                </template>
              </template>
              <template>
                <ValidationObserver rules="required" v-slot="{ handleSubmit }">
                  <RightSideBar
                    v-if="isOpenNewReport"
                    @submit="handleSubmit(submit)"
                    @close="isOpenNewReport = false"
                    button-class="bg-dynamicBackBtn text-white"
                    :disabled-button="isSavingReport"
                  >
                    <template v-slot:title>
                      <p
                        class="text-darkPurple font-bold text-lg leading-5 p-0"
                      >
                        Report New
                      </p>
                    </template>
                    <template>
                      <div>
                        <div
                          class="mb-10 flex flex-col justify-start items-start gap-5"
                        >
                          <Select
                            class="w-full text-sm font-normal leading-5 text-darkPurple"
                            placeholder="--Select--"
                            label="KPA"
                            :options="kpaTypeOptions"
                            :rules="['required']"
                            @input="selectedType($event)"
                            v-model="payload.kpaTypeId"
                          />
                          <Select
                            class="w-full text-sm font-normal leading-5 text-darkPurple"
                            placeholder="--Select--"
                            label="KPI"
                            :options="kpiOptions"
                            :rules="['required']"
                            @input="selectedKPI($event)"
                            v-model="payload.kpiId"
                          />
                          <div
                            class="flex flex-col justify-start item-start gap-1 w-full"
                          >
                            <label for="comment" class="text-sm"
                              >Criteria</label
                            >
                            <Textarea
                              class="w-full text-sm font-normal leading-5 text-darkPurple"
                              label="Criteria"
                              placeholder="`--Autoloads from agreement--`"
                              :disabled="true"
                              :height="130"
                              v-model="payload.criteria"
                            />
                          </div>
                          <TextInput
                            class="w-full text-sm font-normal leading-5 text-darkPurple"
                            label="Weight"
                            placeholder="Auto Calculated"
                            :disabled="true"
                            v-model="weight"
                          />
                          <Select
                            class="w-full text-sm font-normal leading-5 text-darkPurple"
                            placeholder="--Select--"
                            label="Status"
                            :options="optionsStatus"
                            :rules="['required']"
                            v-model="payload.status"
                          />
                          <Select
                            class="w-full text-sm font-normal leading-5 text-darkPurple"
                            placeholder="--Select--"
                            label="Support Required?"
                            :options="supportOptions"
                            :rules="['required']"
                            v-model="payload.requireSupport"
                          />
                          <div
                            class="flex flex-col justify-start item-start gap-1 w-full"
                          >
                            <Textarea
                              class="w-full text-sm font-normal leading-5 text-darkPurple"
                              placeholder="Comment"
                              id="comment"
                              label="Comment"
                              :height="96"
                              :rules="['required']"
                              v-model="payload.comment"
                            />
                          </div>

                          <div
                            v-if="payload.filesPath.length < 5"
                            @click="isUpload = true"
                            class="w-full text-base text-dynamicBackBtn font-normal cursor-pointer flex justify-start items-center gap-1 mt-3 border-t border-solid border-color pt-3"
                          >
                            <Icon icon-name="upload-icon-red" size="s" />
                            <p>Upload</p>
                          </div>

                          <div
                            v-if="payload.filesPath.length > 0"
                            class="w-full h-auto flex flex-col gap-4"
                          >
                            <div class="w-full" />
                            <p
                              class="w-full text-left pb-3 uppercase font-semibold text-romanSilver text-xs border-b border-solid border-color"
                            >
                              Uploaded Files
                            </p>
                            <div class="w-full h-auto flex flex-col gap-4">
                              <div
                                v-for="(file, index) in payload.filesPath"
                                :key="index"
                                class="w-full h-9 flex justify-between items-center gap-6"
                              >
                                <div
                                  class="w-auto flex justify-start items-center gap-1"
                                >
                                  <div class="w-9 h-full">
                                    <icon
                                      icon-name="pdf"
                                      size="xs"
                                      class="icon"
                                      v-if="file.mimeType === 'pdf'"
                                    />
                                    <icon
                                      icon-name="doc"
                                      size="xs"
                                      class="icon"
                                      v-else-if="file.mimeType === 'doc'"
                                    />
                                    <icon
                                      icon-name="xlsx"
                                      size="xs"
                                      class="icon"
                                      v-else-if="file.mimeType === 'xlsx'"
                                    />
                                    <icon
                                      icon-name="csv"
                                      size="xs"
                                      class="icon"
                                      v-else-if="file.mimeType === 'csv'"
                                    />
                                    <icon
                                      icon-name="ppt"
                                      size="xs"
                                      class="icon"
                                      v-else-if="file.mimeType === 'ppt'"
                                    />
                                    <icon
                                      icon-name="png"
                                      size="xs"
                                      class="icon"
                                      v-else-if="file.mimeType === 'png'"
                                    />
                                    <icon
                                      icon-name="jpg"
                                      size="xs"
                                      class="icon"
                                      v-else-if="file.mimeType === 'jpg'"
                                    />
                                    <icon
                                      icon-name="jpg"
                                      size="xs"
                                      class="icon"
                                      v-else-if="file.mimeType === 'jpeg'"
                                    />
                                  </div>

                                  <div
                                    class="flex flex-col justify-center items-start"
                                  >
                                    <p
                                      class="text-blackJet text-base font-semibold py-0 my-0"
                                    >
                                      {{ file.fileName }} {{ file.mimeType }}
                                    </p>
                                    <p class="text-xs py-0 my-0">
                                      <span class="text-blueCrayola">
                                        {{ `document` }}
                                      </span>
                                      <span class="text-romanSilver">
                                        • {{ file.fileSize.toFixed(2) }}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                                <div
                                  class="flex justify-center items-center gap-1"
                                >
                                  <div
                                    @click="downloadFile(file)"
                                    class="cursor-pointer h-full w-9"
                                  >
                                    <Icon
                                      icon-name="black-download-icon"
                                      size="s"
                                      class="icon"
                                    />
                                  </div>
                                  <div
                                    @click="deleteUploadedFile(index)"
                                    class="cursor-pointer h-full w-9"
                                  >
                                    <icon
                                      icon-name="trash-icon"
                                      size="s"
                                      class="icon"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <UploadFile
                          v-if="isUpload"
                          @close="isUpload = false"
                          @set-files="setFiles"
                        />
                        <DownloadFile
                          v-if="openDownloadFile"
                          @close="openDownloadFile = false"
                          :item="selectedItem"
                        />
                      </div>
                    </template>
                  </RightSideBar>
                </ValidationObserver>
              </template>
              <template>
                <RightSideBar
                  v-if="statusModal"
                  @close="statusModal = false"
                  :closeButton="true"
                  button-class="bg-dynamicBackBtn text-white"
                >
                  <template v-slot:title>
                    <div class="w-full flex justify-between items-center">
                      <span
                        class="text-darkPurple font-bold text-lg leading-5 p-0"
                        >Report New</span
                      >
                    </div>
                  </template>
                  <StatusReport
                    :kpasItem="kpasItem"
                    :kpaTypes="kpaTypes"
                    :edit="false"
                    :isView="true"
                  />
                </RightSideBar>
              </template>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import BackButton from "@scelloo/cloudenly-ui/src/components/back-button";
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import Datepicker from "vuejs-datepicker";
import Select from "@scelloo/cloudenly-ui/src/components/select";
import Textarea from "@scelloo/cloudenly-ui/src/components/text-area";
import Badge from "@scelloo/cloudenly-ui/src/components/badge";
import Table from "@scelloo/cloudenly-ui/src/components/table";
import Card from "@scelloo/cloudenly-ui/src/components/card";
import TextInput from "@scelloo/cloudenly-ui/src/components/text";
import Loader from "@/components/Loader";
import RightSideBar from "@/components/RightSideBar";
import StatusReport from "@/components/StatusReport";
import Menu from "@/components/Menu";
import UploadFile from "@/components/UploadFile";
import DownloadFile from "@/components/documents/DownloadFile";

export default {
  name: "EssStatusReport",
  components: {
    Breadcrumb,
    BackButton,
    ValidationObserver,
    Badge,
    Select,
    Textarea,
    TextInput,
    Datepicker,
    RightSideBar,
    Loader,
    Card,
    Table,
    StatusReport,
    Menu,
    UploadFile,
    DownloadFile,
  },
  props: {
    hideTab: {
      type: Boolean,
      default: false,
    },
    hideOverview: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      breadcrumbs: [
        {
          disabled: false,
          text: "Performance",
          href: "Performance",
          id: "Performance",
        },
        {
          disabled: false,
          text: "Performance Reports",
          href: "performance-reports",
          id: "PerformanceReports",
        },
      ],
      openModal: false,
      isLoading: true,
      isOpenNewReport: false,
      statusReport: false,
      paginationList: {
        page: 1,
        lastPage: 1,
        total: 1,
        from: 1,
        to: 1,
      },
      optionsStatus: [
        { id: "completed", name: "Completed" },
        { id: "work_in_progress", name: "Work-in-Progress" },
        { id: "on_hold", name: "On-Hold" },
        { id: "cancelled", name: "Cancelled" },
      ],
      header: [
        { title: "KPA", value: "kpa" },
        { title: "KPI", value: "kpi" },
        { title: "criteria", value: "criteria" },
        { title: "Weight", value: "weight" },
        { title: "support required?", value: "support" },
        { title: "comments", value: "comments" },
        { title: "status", value: "status" },
        { title: "", value: "id", image: true },
      ],
      employeeData: {
        photo: "",
        designation: "",
        function: "",
        lineManager: "",
        employeeId: "",
        location: "",
        fname: "",
        lname: "",
        userId: "",
      },
      kpiCount: "",
      reported: "",
      completedRate: "",
      completedWeight: "",
      reports: [],
      kpaTypeOptions: [],
      kpaOptions: [],
      agreementKPA: [],
      kpiOptions: [],
      weight: "",
      targetDate: "",
      supportOptions: [
        {
          id: "1",
          name: "Yes",
        },
        {
          id: "2",
          name: "No",
        },
      ],
      payload: {
        employeeAgreementId: "",
        orgId: "",
        kpiId: "",
        kpaTypeId: "",
        status: "",
        criteria: "",
        currentAchievement: "",
        requireSupport: "",
        comment: "",
        employeeId: "",
        filesPath: [],
      },
      kpasItem: {},
      kpaTypes: {},
      statusModal: false,
      isUpload: false,
      isUploaded: false,
      selectedItem: {},
      openDownloadFile: false,
      isSavingReport: false,
    };
  },
  computed: {
    shouldShowReportButton() {
      const eachUserId = this.id;
      const userId = this.$AuthUser.id;
      const paramId = this.$route.params.id;

      if (eachUserId) {
        return userId === eachUserId;
      } else if (paramId) {
        return userId === paramId;
      } else {
        return true;
      }
    },
  },
  methods: {
    getStatusReports() {
      const eachUserId = this.id;
      const userId = this.$AuthUser.id;
      const year = this.$route.params.year;
      const paramId = this.$route.params.id;
      this.reports = [];
      this.$_getStatusReportEmployee(
        ...(eachUserId
          ? [year, eachUserId]
          : year && !paramId
          ? [year, userId]
          : [year, paramId])
      )
        .then((response) => {
          this.statusReport = true;
          const employeeData = response.data.data.employee;

          this.employeeData.photo = employeeData.photo;
          this.employeeData.designation = employeeData.designation;
          this.employeeData.function = employeeData.function;
          this.employeeData.lineManager = employeeData.lineManager
            ? `${employeeData.lineManager.fname} ${employeeData.lineManager.lname}`
            : "---";
          this.employeeData.employeeId = "---";
          this.employeeData.location = employeeData.location;
          this.employeeData.fname = employeeData.fname;
          this.employeeData.lname = employeeData.lname;
          this.employeeData.userId = employeeData.userId;

          this.kpiCount = response.data.data.kpiCount;
          this.reported = response.data.data.reported;
          this.completedRate = response.data.data.completedRate;
          this.completedWeight = response.data.data.completedWeight;

          const reportArr = response.data.data.reports;
          reportArr.map((reports) => {
            this.reports.push({
              kpa: reports.kpa_type.name,
              kpi: reports.kpa.name,
              criteria: reports.criteria.replace(/\n/g, " "),
              weight: reports.weight ? reports.weight : "---",
              support: reports.requireSupport ? "Yes" : "No",
              comments: reports.comment,
              status: reports.status,
              id: reports.id,
              files: reports.files,
            });
            return {};
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    selectedType(value) {
      this.kpiOptions = [];

      this.agreementKPA.map((kpaDetails) => {
        if (kpaDetails.kpa_type.id === value) {
          this.kpiOptions.push({
            id: kpaDetails.id,
            name: kpaDetails.name,
          });
        }
        return {};
      });
    },

    selectedKPI(value) {
      const kpisArr = [];

      this.agreementKPA.map((kpaDetails) => {
        if (kpaDetails.id === value) {
          kpaDetails.kpis_employee.map((kpis) => {
            kpisArr.push(`${kpis.criteria}\n \n`);

            this.payload.criteria = kpisArr.toString().replace(/,/g, "");

            return {};
          });

          this.weight = kpaDetails.weight;
          this.targetDate = this.resetDate(kpaDetails.targetDate);
        }
        return {};
      });
    },

    resetDate(value) {
      if (value) {
        const dateValue = value;

        const split = dateValue.split("T00:00:00.000Z");

        return `${split[0]}T13:00:00.000Z`;
      }
      return "";
    },

    getAgreements() {
      this.$_getEmployeeAgreement(
        this.$route.params.id || this.$AuthUser.id
      ).then((response) => {
        const myAgreements = response.data.EmployeePerformanceAgreements;

        myAgreements.map((agreement) => {
          if (
            Number(agreement.year) === Number(this.$route.params.year) &&
            agreement.approvedByAdmin
          ) {
            this.payload.employeeAgreementId = agreement.id;
            this.payload.orgId = this.$orgId;

            const agreementKPA = agreement.employee_agreement_kpa;

            this.agreementKPA = agreementKPA;

            agreementKPA.map((kpaDetails) => {
              if (!this.kpaOptions.includes(kpaDetails.kpa_type.id)) {
                this.kpaTypeOptions.push(kpaDetails.kpa_type);
              }

              this.kpaOptions.push(kpaDetails.kpa_type.id);

              return {};
            });
          }

          return {};
        });
      });
    },

    submit() {
      this.isSavingReport = true;
      if (this.payload.requireSupport === "1") {
        this.payload.requireSupport = true;
      }

      if (this.payload.requireSupport === "2") {
        this.payload.requireSupport = false;
      }

      this.payload.employeeId = this.$AuthUser.id;
      this.$_postStatusReport(this.payload)
        .then((response) => {
          this.$toasted.success(response.data.message, { duration: 5000 });
          this.isOpenNewReport = false;
          this.isSavingReport = false;
          this.kpaTypeOptions = [];
          this.kpaOptions = [];
          this.isLoading = true;
          this.getStatusReports();
          this.getAgreements();
          this.resetForm();
        })
        .catch((err) => {
          this.isSavingReport = false;
          this.$toasted.error(err.response.data.message, { duration: 5000 });
        });
    },

    resetForm() {
      this.payload.employeeAgreementId = "";
      this.payload.orgId = "";
      this.payload.kpiId = "";
      this.payload.kpaTypeId = "";
      this.payload.status = "";
      this.payload.criteria = "";
      this.payload.currentAchievement = "";
      this.payload.requireSupport = "";
      this.payload.comment = "";
      this.payload.employeeId = "";
    },
    viewReport(kpasItem, kpaTypes) {
      this.statusModal = true;
      this.kpasItem = kpasItem;
      this.kpaTypes = kpaTypes;
    },
    setFiles(files) {
      if (this.payload.filesPath.length > 0) {
        const allFiles = [...this.payload.filesPath, ...files];
        this.payload.filesPath = allFiles;
      } else {
        this.payload.filesPath = [...files];
      }
    },
    deleteUploadedFile(index) {
      if (this.payload.filesPath.length > 1) {
        this.payload.filesPath.splice(index, 1);
      } else {
        this.payload.filesPath.splice(index, 1);
        this.isUploaded = false;
      }
    },
    downloadFile(file) {
      this.openDownloadFile = true;
      this.selectedItem = file;
    },
  },

  mounted() {
    this.getStatusReports();
    this.getAgreements();
  },
};
</script>

<style>
.button_class {
  padding: 10px 40px !important;
  font-weight: 600;
  display: flex;
  justify-self: end;
}

.button-class-pimary {
  font-weight: 600 !important;
  font-size: 16px !important;
  padding: 10px 40px !important;
}

.button-class-secondary {
  color: #321c3b !important;
  background: white !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  padding: 10px 40px !important;
}

.border-color {
  border-color: #00000029;
}
</style>
